<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <input :id="id" ref="input" v-bind="{ ...$attrs, class: null }" maxlength="15" class="form-input" :class="{ error: error }" :type="type" :value="modelValue" @input="emitValue" />
    <div v-if="modelValue" class="absolute right-5 top-9 mr-5">
      <a :href="'tel:+'+phoneFormatted(modelValue)"> <i class="text-lg fas fa-phone-alt text-green-500" /></a> <a :href="'sms:+'+phoneFormatted(modelValue)"> <i class="ml-2 text-lg fas fa-sms text-blue-500" /></a>
    </div>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `phone-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    modelValue: String,
    modelModifiers: {
      default: () => ({}),
    },
  },
  emits: ['update:modelValue'],
  methods: {
    emitValue(e) {
      let phone = e.target.value
      if (this.modelModifiers.phoneFormat) {
        if(phone !== null){
          phone=phone.replace(/[^0-9]+/gi, '')
          if(phone.startsWith(1) == true){
            phone = phone.substring(1)
          }
          var max_chars = 10
          if(phone.length > max_chars) {
            phone = phone.substr(0, max_chars)
          }
          phone = phone.replace(/(\d{3})(\d{3})(\d{4})/,'$1-$2-$3')
        }
        else {
          phone = null
        }
      }
      this.$emit('update:modelValue', phone)
    },
    phoneFormatted: function () {
      let phone = this.modelValue
      if(phone !== null){
        // phone=phone.replace(/[\s()-/+]+/gi, '')
        phone=phone.replace(/[^0-9]+/gi, '')
        if(phone.startsWith(1) != true){
          phone = '1'+phone
        }
        return phone
      }
      else {
        phone = null
        return phone
      }
    },
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
